module.exports = __webpack_public_path__ + "media/images/beauty/cover-desktop-00415b4b0a07339a971d11a77fc2b272.jpg";